import { createAction, createReducer } from '@reduxjs/toolkit';

import type { SharedModalState } from './sharedModal.types';

const initialState: SharedModalState = {
    weblinkOpened: false,
};

const setWeblinkOpened = createAction<{ opened: boolean }>('sharedModal/setWeblinkOpened');

const buyOnboardingSubscription = createAction('sharedModal/buyOnboardingSubscription');

export const sharedModalReducer = createReducer(initialState, {
    [setWeblinkOpened.type]: (state, action: ReturnType<typeof setWeblinkOpened>) => {
        state.weblinkOpened = action.payload.opened;
    },
});

export const SharedModalActions = {
    setWeblinkOpened,
    buyOnboardingSubscription,
} as const;
